import { isArray } from 'util';

import { Trader } from '../trader';
import { sortByString, mapCollection } from '../../utils/collection.utils';

export class TraderBuilder {

  static fromJson(json): Trader {
    return (json) ? new Trader(
      json.hash,
      json.firstName,
      json.lastName,
      json.email,
      json.signatureLink
    ) : null;
  }

  static fromJsonList(list): Trader[] {
    return (isArray(list)) ? sortByString('firstName', mapCollection(TraderBuilder.fromJson, list)) : [];
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/core/models/builders/trader-builder.ts